var _path, _path2;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8411 26.74V2.62601C19.8408 2.54075 19.8211 2.45707 19.7838 2.38332C19.7466 2.30956 19.6932 2.24832 19.6289 2.20569C19.2145 1.9267 18.0946 1.39917 15.5968 1.39917C12.2015 1.39917 7.90419 4.32311 5.41071 4.32311C4.00291 4.31891 2.60998 3.99233 1.31344 3.36247C1.2973 3.35474 1.27974 3.35171 1.26233 3.35365C1.24493 3.35559 1.22821 3.36245 1.21366 3.3736C1.19912 3.38475 1.1872 3.39986 1.17897 3.41758C1.17074 3.4353 1.16645 3.45508 1.16649 3.47517V16.8376C1.16661 16.8847 1.17865 16.9309 1.20116 16.9703C1.22367 17.0098 1.25567 17.0409 1.29328 17.0599C1.73044 17.2798 3.27109 17.9682 5.41071 17.9682C7.95724 17.9682 12.2015 16.0189 15.5968 16.0189C18.9922 16.0189 19.8411 16.9935 19.8411 16.9935",
    fill: "#FF3D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8411 26.74V2.62601C19.8408 2.54075 19.8211 2.45707 19.7838 2.38332C19.7466 2.30956 19.6932 2.24832 19.6289 2.20569C19.2145 1.9267 18.0946 1.39917 15.5968 1.39917C12.2015 1.39917 7.90419 4.32311 5.41071 4.32311C4.00291 4.31891 2.60998 3.99233 1.31344 3.36247C1.2973 3.35474 1.27974 3.35171 1.26234 3.35365C1.24493 3.35559 1.22821 3.36245 1.21366 3.3736C1.19912 3.38475 1.1872 3.39986 1.17897 3.41758C1.17074 3.4353 1.16645 3.45508 1.16649 3.47517V16.8376C1.16661 16.8847 1.17865 16.9309 1.20116 16.9703C1.22367 17.0098 1.25567 17.0409 1.29328 17.0599C1.73044 17.2798 3.27109 17.9682 5.41071 17.9682C7.95724 17.9682 12.2015 16.0189 15.5968 16.0189C18.9922 16.0189 19.8411 16.9935 19.8411 16.9935",
    stroke: "#202020",
    strokeWidth: 1.68138,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.c7ff6a61327a8b8e8cefc4a88c483863.svg";
export { ForwardRef as ReactComponent };